import { api } from "../index";

export const leaderboard = api.injectEndpoints({
  endpoints: (builder) => ({
    getAdminLeaderboard: builder.query({
      query: ({ page = 1, perPage = 10, keyword }) =>
        keyword
          ? `/api/v1/organization/users/leaderboard?page=${page}&per_page=${perPage}&filters[keyword]=${keyword}`
          : `/api/v1/organization/users/leaderboard?page=${page}&per_page=${perPage}`,
      providesTags: ["User"],
    }),
  }),
});

export const { useGetAdminLeaderboardQuery } = leaderboard;
